import React from 'react';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';

import "./style.scss";

import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/a11y/a11y.scss';

const breakpoints = {
  350: { slidesPerView: 3.6, spaceBetween: 12 },
  450: { slidesPerView: 4.6, spaceBetween: 12 },
  550: { slidesPerView: 5.6, spaceBetween: 12 },
  650: { slidesPerView: 6.6, spaceBetween: 12 },
  750: { slidesPerView: 7.8, spaceBetween: 16 },
  850: { slidesPerView: 8.8, spaceBetween: 16 },
  950: { slidesPerView: 9.8, spaceBetween: 16 },
  1050: { slidesPerView: 10.8, spaceBetween: 16 },
};

function Sliders({content}) {
  const [publications] = useFetch("/publication?acf_format=standard", []);
  const slides = publications.filter(publication => publication.acf.publication_type.value === content.publication_type.value);
  if (!slides.length) return null;
  return (
    <Slider slides={slides} title={content.publication_type.label} />
  );
}

function Slider({slides, title}) {
  return (
    <div className="Slider">
      <h2 className="Slider__title">{title}:</h2>
      <Swiper
        modules={[Navigation, A11y]}
        spaceBetween={12}
        slidesPerView={2.4}
        navigation={{
          prevEl: ".Slider__button--left",
          nextEl: ".Slider__button--right",
          disabledClass: "Slider__button--hidden",
        }}
        breakpoints={breakpoints}
        // slidesOffsetBefore={16}
        // slidesOffsetAfter={16}
      >
        <button className="Slider__button Slider__button--left">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M28.05 36 16 23.95 28.05 11.9l2.15 2.15-9.9 9.9 9.9 9.9Z"/></svg>
        </button>
        <button className="Slider__button Slider__button--right">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="m18.75 36-2.15-2.15 9.9-9.9-9.9-9.9 2.15-2.15L30.8 23.95Z"/></svg>
        </button>
        {slides.map(slide => (
          <SwiperSlide key={slide.id}>
            <SliderDetails publication={slide} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

function SliderDetails({publication}) {
  return publication.acf.see_more_details ? (
    <Link to={publication.link} className="Slider__link">
      <img className="Slider__image" src={publication.acf.image.sizes.thumbnail} alt={publication.acf.image.alt} />
    </Link>
  ) : (
    <span className="Slider__link">
      <img className="Slider__image" src={publication.acf.image.sizes.thumbnail} alt={publication.acf.image.alt} />
    </span>
  )
}

export default Sliders;
